import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EmployerPlan } from '../../../../models/employers/plans/employer-plan';

@Component({
  selector: 'app-employer-record-plan-overview',
  templateUrl: './employer-record-plan-overview.component.html',
  styleUrls: ['./employer-record-plan-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordPlanOverviewComponent {
  @Input() plan!: EmployerPlan;
  @Input() isLoading: boolean = false;
}
